// Single entry JS bundle for the theme
// Includes: lucide init, FAQ accordion, slider extras (previous separate files)

(function(){
  // Lucide init
  function initLucide(){
    if(window.lucide && typeof lucide.createIcons === 'function'){
      try{ lucide.createIcons(); }catch(e){}
    }
  }

  // FAQ accordion toggle
  function onFaqClick(e){
    var btn = e.target.closest && e.target.closest('[data-faq-toggle]');
    if(!btn) return;
    var targetId = btn.getAttribute('aria-controls');
    var panel = targetId && document.getElementById(targetId);
    if(!panel) return;
    var expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    panel.hidden = expanded;
  }

  // Slider extras
  function setLucideArrows(ctx){
    try{
      var prev=(ctx||document).querySelector('.slider-prev-icon');
      var next=(ctx||document).querySelector('.slider-next-icon');
      if(prev){
        prev.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-left"><polyline points="15 18 9 12 15 6"/></svg>';
      }
      if(next){
        next.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right"><polyline points="9 18 15 12 9 6"/></svg>';
      }
    }catch(e){}
  }

  function applySlideGutter($slider, gutter){
    try{
      var $ = window.jQuery;
      if(!$ || !$slider || !$slider.length) return;
      var $track = $slider.find('.slick-track');
      var $slides = $slider.find('.slick-slide');
      $slides.css({ marginRight: gutter + 'px' });
      $track.css({ marginRight: '-' + gutter + 'px' });
    }catch(e){}
  }

  function init(){
    document.addEventListener('click', onFaqClick);
    setLucideArrows(document);
    initLucide();

    if(window.jQuery && jQuery.fn && jQuery.fn.slick){
      var $ = window.jQuery;
      var $s = $('.responsive-item-models-slider');
      if($s.length){
        if($s.hasClass('slick-initialized')){
          applySlideGutter($s, 20);
          setLucideArrows(document);
        }
        $s.on('init setPosition reInit', function(){
          applySlideGutter($s, 20);
          setLucideArrows(document);
        });
      }
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  }else{
    init();
  }
})();